(function () {
  var qs = function (s, r) { return (r || document).querySelector(s); };
  var qsa = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var designMode = function () { return !!(window.Shopify && window.Shopify.designMode); };

  document.addEventListener('submit', function (e) {
    if (designMode() && e.target && e.target.matches && e.target.matches('[data-s3-form]')) e.preventDefault();
  });

  document.addEventListener('click', function (e) {
    var more = e.target.closest('[data-s3-more]');
    if (!more) return;
    var text = more.previousElementSibling;
    if (text) text.classList.add('is-open');
  });

  function initGallery(scope) {
    qsa('[data-s3-gallery]', scope).forEach(function (g) {
      var track = qs('.s3-gal__track', g);
      var slides = qsa('.s3-gal__slide', g);
      var thumbs = qsa('.s3-gal__thumb', g);
      var strip = qs('.s3-gal__thumbs', g);
      if (!track || slides.length === 0) return;
      var idx = 0;
      var setActive = function (i) {
        idx = i;
        thumbs.forEach(function (t, k) {
          t.classList.toggle('is-active', k === i);
          t.setAttribute('aria-current', k === i ? 'true' : 'false');
        });
        var th = thumbs[i];
        if (strip && th) strip.scrollTo({ left: th.offsetLeft - strip.offsetLeft - strip.clientWidth / 2 + th.clientWidth / 2, behavior: 'smooth' });
      };
      var go = function (i) {
        var n = (i + slides.length) % slides.length;
        track.scrollTo({ left: n * track.clientWidth, behavior: 'smooth' });
        setActive(n);
      };
      thumbs.forEach(function (t, k) { t.addEventListener('click', function () { go(k); }); });
      var prev = qs('[data-s3-prev]', g), next = qs('[data-s3-next]', g);
      if (prev) prev.addEventListener('click', function () { go(idx - 1); });
      if (next) next.addEventListener('click', function () { go(idx + 1); });
      var timer;
      track.addEventListener('scroll', function () {
        clearTimeout(timer);
        timer = setTimeout(function () {
          var i = Math.round(track.scrollLeft / track.clientWidth);
          if (i !== idx) setActive(i);
        }, 80);
      }, { passive: true });
      setActive(0);
    });
  }

  function initCarousels(scope) {
    qsa('[data-s3-carousel]', scope).forEach(function (c) {
      var track = qs('.s3-car__track', c);
      var cards = qsa('.s3-car__card', c);
      var dots = qsa('.s3-car__dot', c);
      if (!track || cards.length === 0) return;
      var idx = 0;
      var paint = function (i) {
        idx = i;
        dots.forEach(function (d, k) { d.classList.toggle('is-active', k === i); });
      };
      var go = function (i) {
        var n = (i + cards.length) % cards.length;
        track.scrollTo({ left: cards[n].offsetLeft - cards[0].offsetLeft, behavior: 'smooth' });
        paint(n);
      };
      dots.forEach(function (d, k) { d.addEventListener('click', function () { go(k); }); });
      var prev = qs('[data-s3-car-prev]', c), next = qs('[data-s3-car-next]', c);
      if (prev) prev.addEventListener('click', function () { go(idx - 1); });
      if (next) next.addEventListener('click', function () { go(idx + 1); });
      var timer;
      track.addEventListener('scroll', function () {
        clearTimeout(timer);
        timer = setTimeout(function () {
          var best = 0, bestD = Infinity;
          cards.forEach(function (card, k) {
            var dist = Math.abs(card.offsetLeft - cards[0].offsetLeft - track.scrollLeft);
            if (dist < bestD) { bestD = dist; best = k; }
          });
          paint(best);
        }, 80);
      }, { passive: true });
      if (c._s3) clearInterval(c._s3);
      var secs = parseInt(c.getAttribute('data-autoplay') || '0', 10);
      if (secs > 0 && !designMode()) {
        var paused = false;
        ['mouseenter', 'touchstart', 'focusin'].forEach(function (ev) { c.addEventListener(ev, function () { paused = true; }, { passive: true }); });
        ['mouseleave', 'focusout'].forEach(function (ev) { c.addEventListener(ev, function () { paused = false; }); });
        c._s3 = setInterval(function () { if (!paused) go(idx + 1); }, secs * 1000);
      }
      paint(0);
    });
  }

  function init(scope) {
    initGallery(scope);
    initCarousels(scope);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
